import React from 'react'
import update from 'react-addons-update';

class ASelectV4 extends React.PureComponent {
    constructor(props) {
        super(props);
        this.selectOnChange = this.selectOnChange.bind(this);
        this.componentName = "[aSelectV4.jsx]";
        this.state = {
            errorMessage: null
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.maxlength !== undefined && nextprops.maxlength !== null) {
            this.setState({ errorMessage: nextprops.errorMessage });
        }
    }

    onChange(event) {
        this.setState({ errorMessage: null });
    }

    selectOnChange(item) {
        console.log(this.componentName + "selectOnChange item= " + item);

        let valKey = this.props.valueKey || "value";
        this.setState({ errorMessage: null });

        if (this.props.onChange) {
            this.props.onChange(item);
        }
        // this.onInputChange(Utils.getVal(valKey, item));
    }


    render() {


        let messaggioDiErrore = null;
        let spanDiErrore = null;
        let formClass = 'form-group ';
        let className = "";


        let classNameComponent = 'form-group ' + (this.props.classNameComponent === undefined ? "" : this.props.classNameComponent)
        console.log(this.componentName + "classNameComponent [" + classNameComponent + "]");

        let classNameLabel = "" + (this.props.classNameLabel === undefined ? "" : this.props.classNameLabel);

        let classNameSelect = "form-control " + (this.props.classNameSelect === undefined ? "" : this.props.classNameSelect);



        let val = this.props.value;


        if (val === undefined || val === null) {
            val = "";
        }

        let items = this.props.items || [];
        let valueKey = this.props.valueKey || "value";
        let labelKey = this.props.labelKey || "label";

        let label = this.props.label;
        if (this.props.required !== undefined && this.props.required) {
            console.log(this.componentName + "required is true");
            if (label.indexOf('*') === -1) {
                label = label + '*';
            }
        }
        let isDisabled;
        if (this.props.disabled === undefined || this.props.disabled === null || this.props.disabled !== true) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }
        if (this.props.validation !== undefined) {
            //for (var [key, value] of this.props.validation) {
            //  console.log(key + ' = ' + value);
            //}

            //cerco un eventuale messaggio di errore per il mio componente
            let errore = this.props.validation.get(this.props.id);
            //console.log('Errore: ' + errore);

            if (errore !== undefined) {
                formClass += ' has-error has-feedback';
                //	spanClass = 'glyphicon glyphicon-remove form-control-feedback';
                // messaggioDiErrore = <span className="text-danger small">{errore}</span>;
                classNameSelect += " is-invalid";
                messaggioDiErrore = (<small className="invalid-feedback d-block" >
                    <i aria-hidden="true" className='fa fa-times'></i> {' '}
                    {errore}
                </small>);
                { errore }
                spanDiErrore = <span className='glyphicon glyphicon-remove form-control-feedback' aria-hidden="true"></span>;
            }
        }
        if (this.state.errorMessage !== null) {
            formClass += ' has-error has-feedback';
            //	spanClass = 'glyphicon glyphicon-remove form-control-feedback';
            messaggioDiErrore = <span className="text-danger small">{this.state.errorMessage}</span>;
            spanDiErrore = <span className='glyphicon glyphicon-remove form-control-feedback' aria-hidden="true"></span>;
        }
        if (this.props.addEmptyOption === undefined || this.props.addEmptyOption) {
            console.log(this.componentName + "addEmptyOption is true");

            let it = {};
            it[valueKey] = "";
            it[labelKey] = " ";
            it.id = {};

            items = update(items, { $unshift: [it] });
            // items.unshift(it);
        }


        console.log(this.componentName + 'render [id] ' + this.props.id, items);
        //console.log("option key [" + item[valueKey] + "] - label [" + item[labelKey] + "]");
        return (
            <div className={classNameComponent}>
                <label className={classNameLabel} htmlFor={this.props.id}>{label}</label>

                <select className={classNameSelect} onChange={this.selectOnChange} id={this.props.id}
                    name={this.props.name}
                    disabled={isDisabled}>
                    {
                        items === null ? null : items.map((item, index) =>
                            <option selected={this.props.value === item[valueKey]} key={index} value={item[valueKey]} >{item[labelKey]}</option>
                        )
                    }
                </select>
                {spanDiErrore}
                {messaggioDiErrore}

            </div>
        );
    }
}
export default ASelectV4;